import { StyledBetaTag } from './styles';

export const BetaTag = ({ className }: { className?: string }) => (
  <StyledBetaTag className={className} data-automation="BetaTag">
    BETA
  </StyledBetaTag>
);
